import createAuth0Client, { Auth0Client } from '@auth0/auth0-spa-js';
import {InlineConfig} from "../config/configs";
import {dynamicEnv} from "../config/dynamic/dynamicEnv";

let auth0client: Auth0Client | null = null;

export type AuthConfig = Pick<InlineConfig, "AUTH0_CLIENT_ID" | "AUTH0_AUDIENCE" | "AUTH0_DOMAIN" | "AUTHENTICATION_TOKEN">;
export type ProvideAuthToken = (backendUrl: string, inlineConfig: AuthConfig) => Promise<string>;

export const provideToken: ProvideAuthToken = async (backendUrl: string, inlineConfig: AuthConfig): Promise<string> => {
  if (inlineConfig.AUTHENTICATION_TOKEN) {
    return inlineConfig.AUTHENTICATION_TOKEN;
  }

  const userName = dynamicEnv('USERNAME');
  const password = dynamicEnv('PASSWORD');
  if (userName && password) {
    return loginUser(backendUrl, { userName, password });
  }

  try {
    return await pullTokenAuth0(inlineConfig);
  } catch (e) {
    console.log("user not logged in, for preview or student it's ok", e);
  }

  return '';
}

async function pullTokenAuth0(inlineConfig: AuthConfig): Promise<string> {
  if (!inlineConfig.AUTH0_CLIENT_ID || !inlineConfig.AUTH0_DOMAIN || !inlineConfig.AUTH0_AUDIENCE) {
    //throw Error('auth0 not configure well'); //for es lint

    console.log('authtnetication not configure well');
    return '';
  }
  if (!auth0client) {
    auth0client = await createAuth0Client({
      domain: inlineConfig.AUTH0_DOMAIN,
      audience: inlineConfig.AUTH0_AUDIENCE,
      client_id: inlineConfig.AUTH0_CLIENT_ID,
      cacheLocation:  'localstorage',
    });
  }

  return await auth0client.getTokenSilently();
}

async function loginUser(backendUrl: string, credentials: { userName: string, password: string }): Promise<string> {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json;charset=UTF-8');

  try {
    const response = await fetch(`${backendUrl}/api/GenerateToken`, {
      headers,
      method: 'POST',
      body: JSON.stringify({
        username: credentials.userName,
        password: credentials.password,
      }),
    });

    type AuthResult = { token: string };

    return ((await response.json()) as AuthResult).token;
  } catch (e) {
    alert('Provided credentials in local.config are not valid.');
    throw e;
  }
}
